var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.929 5-7.071 7.071 7.07 7.071"
})));
SvgChevron.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevron);
export default ForwardRef;